<div class="fixed bottom-3 start-3">
    <a [routerLink]="'/home'" class="back-button btn btn-icon bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full">
      <i data-feather="arrow-left" class="h-4 w-4"></i>
    </a>
</div>
